export default $dispatch => ({
    copyWithNotificationAndEvent(notification) {
        this.copy(this.$refs.inputWithText.value).then(() => {
            this.sendNotification(notification);
        });
    },

    copy(text) {
        if (navigator.clipboard) {
            return navigator.clipboard.writeText(text);
        }

        return this.fallbackCopy(text);
    },

    fallbackCopy(text) {
        return new Promise((resolve, reject) => {
            const textArea = document.createElement('textarea');
            textArea.value = text;

            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.position = 'fixed';

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
            } catch (err) {
                reject('Unable to copy to clipboard', err);
            }

            document.body.removeChild(textArea);

            resolve();
        });
    },

    sendNotification(notification) {
        $dispatch('notify', {
            message: notification,
        });
    },
});
